import { gql } from "@apollo/client";

export const SUBSCRIPTION_USER_ALERT_TRACKING = gql`
  query SUBSCRIPTION_USER_ALERT_TRACKING($initialDate: timestamp, $finalDate: timestamp) {
    userAlertTracking(where: {created_at: {_gte: $initialDate, _lte: $finalDate}}, order_by: {created_at: desc}) {
      id
      userId
      doctorId
      alertStatusId
      alertTypeId
      isDrugTaken
      drugName
      drugComment
      userDrugHistoryId
      measure
      userVitalSignHistoryId
      sideEffectName
      sideEffectSeverity
      userSideEffectHistoryId
      userReportDate
      doctorComment
      created_at
      updated_at
      processId
      vitalSignComment
      sideEffectComment
      alertSeverity
      vitalSignName
      userComment
      userToProcessId
      processName
      sideEffectSeverityDescription
      user {
        id
        name
        lastname
        picture
        phone
        phoneCarer
        nameCarer
      }
    }
  }
`
